import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '../environments/environment';
import { AuthService } from './shared/services/auth.service';
import { AccessLevelService } from './shared/services/acl.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private auth: AuthService,
    private ACLS: AccessLevelService,
  ) {
    router.events.subscribe((res) => {
      if (res instanceof NavigationEnd) {
        if (res.url.indexOf('availability') === -1) {
          setTimeout(() => {
            environment.scrollToTop();
          }, 500);
        }
        // } else {
        //   console.log('$$ROUTER: ', res)
      }
    });
  }

  ngOnInit() {
    this.auth.getCurrentUserData().subscribe({
      next: (user) => {
        this.ACLS.init(user);
      },
      error: () => {
        // No user in localStorage (e.g. login page) — skip ACL init.
      },
    });
  }
}
